import keys from '@debbie/common/dist/cache/keys.js';
import * as api from '../api/customers.js';
import { billingVouchersEntity } from '../billing-vouchers/index.js';
import q from '../query.js';
export const customersEntity = 'customers';
const pendingCustomerOverpaymentsKey = (customerId) => `customers-${customerId}-pending-overpayments`;
export const usePendingCustomerOverpayments = (customerId) => q.query(pendingCustomerOverpaymentsKey(customerId), () => api.findPendingOverpayments(customerId), [
    ...keys.read.item(customersEntity, customerId),
    ...keys.read.collection(billingVouchersEntity),
], {
    enabled: customerId != null,
});
export const customerKey = (id) => `customer-${id}`;
export const useCustomer = (id) => q.query(customerKey(id), () => api.getById(id), keys.read.item(customersEntity, id), { enabled: id != null });
export const ensureCustomerLoaded = (id) => q.ensureLoaded(customerKey(id));
//# sourceMappingURL=index.js.map